import type { StoredOp } from "@envstash/protocol";

/**
 * Merge newly received stored ops into an existing, seq-ordered list, dropping duplicates
 * (by op_id or seq). Returns the merged list and only the ops that were actually new.
 */
export function mergeOps(existing: StoredOp[], incoming: StoredOp[]): { all: StoredOp[]; added: StoredOp[] } {
  const seen = new Set(existing.map((o) => o.op_id));
  const seqs = new Set(existing.map((o) => o.seq));
  const added: StoredOp[] = [];
  for (const op of incoming) {
    if (seen.has(op.op_id) || seqs.has(op.seq)) continue;
    seen.add(op.op_id);
    seqs.add(op.seq);
    added.push(op);
  }
  if (added.length === 0) return { all: existing, added };
  const all = [...existing, ...added].sort((a, b) => a.seq - b.seq);
  return { all, added };
}

export function lastSeq(ops: StoredOp[]): number {
  return ops.length === 0 ? 0 : (ops[ops.length - 1]?.seq ?? 0);
}
